import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from '@mui/icons-material/Cancel';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getFormMode } from "../../../../lib/helpers";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import {
  getMstPromoCodeAuthdrp,
  getMstPromoCodedrp,
  insertMstPromoCodeCoupon,
  retriveMstPromoCodeCoupon,
  updateMstPromoCodeCoupon,
} from "../../../../Api/GenerateCouponMst/Api";
import { getPropertyMstUserwisedrp } from "../../../../Api/RoomMst/Api";
import { isValidPhone } from "../../../../lib/regexHelpers";
import { z } from "zod";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import { useReactToPrint } from "react-to-print";
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import SendIcon from "@mui/icons-material/Send";
import CustomAutoCompleteNew from "../../../AutoComplete/CustomAutoCompleteNew";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";

const FORM_MODE = getFormMode();

const FORM_INIT_STATE = {
  PropId: "",
  PromoCodeID: "",
  MobileNo: "",
  AuthId: "",
  DiscType: "",
  DiscAmt: "",
  ResidentName: "",
  ApprovalFlag: "",
  Status: "1",
};

const couponFormSchema = z.object({
  PropId: z.number().min(1, "Property is required"),
  PromoCodeID: z.number().min(1, "PromoCode is required"),
  MobileNo: z
    .string()
    .min(1, "Mobile number is required")
    .regex(/^\d+$/, "Mobile number must be numeric"),
  ResidentName: z.string().min(1, "Resident Name is required"),
  AuthId: z.number().min(1, "Authority is required"),
  DiscType: z.string().optional(),
  DiscAmt: z.string().optional(),
  Status: z.enum(["1", "0"]).optional(),
});

const GenerateCouponMaster = () => {
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState(FORM_INIT_STATE);
  const [promocode, setPromocode] = useState([]);
  const [currentCouponId, setCurrentCouponId] = useState(() => {
    return location?.state?.CouponId;
  });
  const [mode, setMode] = useState(() =>
    currentCouponId ? FORM_MODE.read : FORM_MODE.add
  );
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [authorities, setAuthorities] = useState([]);
  const [residentId, setResidentId] = useState("");
  const [properties, setProperties] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isResidentNameEditable, setResidentNameEditable] = useState(false);
  const [Status, setStatus] = useState("1");
  const [couponNo, setCouponNo] = useState();
  const [promoCodeName, setPromoCodeName] = useState();
  const [authorityName, setAuthorityName] = useState();
  const [email, setEmail] = useState();
  const [showSendCouponLink, setShowSendCouponLink] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isRefreshingPromo, setIsRefreshingPromo] = useState(false);
  const [rows, setRows] = useState([]);
  const [DataForPrint, setDataForPrint] = useState({});
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const [autoMail, setAutoMail] = useState(true);
  const [bookId,setBookId]=useState('')

  const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'Name', label: 'Authority', minWidth: 100 },
    { id: 'PropName', label: 'Property', minWidth: 100 },
    { id: 'ResidentName', label: 'Resident', minWidth: 100 },
    { id: 'MobileNo', label: 'MobileNo', minWidth: 100 },
    { id: 'CouponNo', label: 'CouponNo', minWidth: 100 },
  ];

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
      try {
        const res = await axiosInstance.post('MstPromoCodeCoupon/GetMstPromoCodeCouponDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        }
      } catch (err) {
        toast.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  const openAuthorityTab = () => {
    window.open("/coupon-authority");
  };

  const handleRefreshAuthority = async () => {
    setIsRefreshing(true);
    try {
      const response = await axiosInstance.post(`MstPromoCodeAuth/getMstPromoCodeAuthdrp`);
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setAuthorities(Data);
      } else {
        setAuthorities([]);
      }
    } catch (error) {
      console.error("Error refreshing job titles:", error);
    } finally {
      setTimeout(() => {
        setIsRefreshing(false);
      }, 300);
    }
  };

  const handleRefreshPromo = async () => {
    setIsRefreshingPromo(true);
    try {
      const response = await axiosInstance.post(`MstPromoCode/getMstPromoCodedrp`, {
        Flag: "R",
        PromoCodeName: "FM",
      });
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setPromocode(Data);
      } else {
        setPromocode([]);
      }
    } catch (error) {
      console.error("Error refreshing job titles:", error);
    } finally {
      setTimeout(() => {
        setIsRefreshingPromo(false);
      }, 300);
    }
  };

  useEffect(() => {
    setCurrentCouponId(location?.state?.CouponId || null);
    setBookId(location?.state?.BookId)
    if (currentCouponId) {
      fetchGenerateCouponData();
    }
  }, [location]);

  useEffect(() => {
    console.log("Current Coupon ID:", currentCouponId);
    console.log("Form State:", form);
  }, [currentCouponId, form]);

  const handleEmailSentLink = async () => {
    if (!email) {
      toast.warn("Resident email is not registered. Only authority will be notified.", { autoClose: 2000 });
    }

    if (!couponNo || !promoCodeName || !authorityName || !form.ResidentName) {
      toast.error("Required coupon details are missing.", { autoClose: 1000 });
      return;
    }

    const selectedProperty = properties.find(
      (property) => property.Id === form.PropId
    );
    const propertyName = selectedProperty ? selectedProperty.Name : "Your Property";

    const selectedAuthority = authorities.find(
      (authority) => authority.Id === form.AuthId
    );
    const authorityEmail = selectedAuthority ? selectedAuthority.Email : null;

    if (!authorityEmail) {
      toast.error("Authority email address is not registered.", { autoClose: 3000 });
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL;
    const frontendUrl = apiUrl.split('/WebApi/api')[0];
    const approvalLink = `${frontendUrl}/ApprovedCoupen/${currentCouponId}`;

    const residentEmailPayload = {
      PropId: form.PropId,
      UserId: parseInt(sessionStorage.getItem("UserId")) || 1,
      ToEmail: [email],
      Subject: "Coupon Approval Information",
      ImgFolderNm: "",
      Body: `
      <p>Dear <strong>${form.ResidentName}</strong>,</p>
      <p>A new coupon has been generated for you at <strong>${propertyName}</strong>.</p>
      <p><strong>Coupon No.:</strong> ${couponNo}</p>
      <p><strong>Promo Code:</strong> ${promoCodeName}</p>
      <p><strong>Discount:</strong> ${form.DiscAmt}</p>
      <p>This coupon is currently pending approval by the authorized authority. You will receive a notification once the approval process is complete.</p>
      <p>Best regards,<br>Authorised By: <strong>${authorityName}</strong><br><strong>${propertyName}</strong> Management Team</p>
    `,
      DocAttachments: [],
    };

    const authorityEmailPayload = {
      PropId: form.PropId,
      UserId: parseInt(sessionStorage.getItem("UserId")) || 1,
      ToEmail: [authorityEmail],
      Subject: "Coupon Approval Request",
      ImgFolderNm: "",
      Body: `
      <p>Dear <strong>${authorityName}</strong>,</p>
      <p>A new coupon awaits your approval for <strong>${form.ResidentName}</strong> in <strong>${propertyName}</strong>.</p>
      <p><strong>Coupon No.:</strong> ${couponNo}</p>
      <p><strong>Promo Code:</strong> ${promoCodeName}</p>
      <p><strong>Discount:</strong> ${form.DiscAmt}</p>
      <p>Please review and approve the coupon by clicking the link below:</p>
      <p><a href="${approvalLink}" style="color: #635bff; text-decoration: underline;">Approve Coupon</a></p>
      <p>Best regards,<br><strong>${propertyName}</strong> Management Team</p>
    `,
      DocAttachments: [],
    };

    try {
      let residentData = { Status: 0 }; // Assume success if not sending

      // Only send resident email if email exists
      if (email) {
        const residentResponse = await axiosInstance.post("EmailRequest/SendEmail", residentEmailPayload);
        residentData = residentResponse.data;
      }

      // Always send to authority if authority email exists
      const authorityResponse = await axiosInstance.post("EmailRequest/SendEmail", authorityEmailPayload);
      const authorityData = authorityResponse.data;

      if (residentData.Status === 0 && authorityData.Status === 0) {
        toast.success("Emails sent successfully to resident and authority!", { autoClose: 1000 });
      } else {
        if (residentData.Status !== 0) {
          toast.error(residentData.Message || "Failed to send resident email.", { autoClose: 1000 });
        }
        if (authorityData.Status !== 0) {
          toast.error(authorityData.Message || "Failed to send authority email.", { autoClose: 1000 });
        }
      }
    } catch (error) {
      toast.error("Error while sending mail.", error);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setForm((prevData) => ({
      ...prevData,
      Status: updatedStatus,
    }));
  };

  const handleMailStatus = (event) => {
    setAutoMail(event.target.checked);
  };

  const getDiscountLabel = () => {
    const selectedPromoCode = promocode.find(
      (promo) => promo.Id === form.PromoCodeID
    );
    if (selectedPromoCode) {
      return ` ${selectedPromoCode.Name}`;
    }
    return "Discount";
  };

  useEffect(() => {
    if (!UserId) {
      toast.error("Error: UserId is missing in session");
      return;
    }

    (async () => {
      const response = await getPropertyMstUserwisedrp({
        Flag: "",
        UserId: UserId,
      });
      if (response instanceof Error) {
        return console.error("Error: Could not fetch userwise property");
      }
      const {
        data: { Status, Data },
      } = response;
      if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
        setProperties(Data);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await getMstPromoCodedrp({
        Flag: "R",
        PromoCodeName: "FM",
      });
      if (response instanceof Error) {
        return console.error(response.message, { autoClose: 500 });
      }
      const { data: { Status, responseStatusCode, Data }, } = response;
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        setPromocode(Data);
      } else {
        setPromocode([]);
        console.error("Error: Promocode not found");
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await getMstPromoCodeAuthdrp();
      if (response instanceof Error) {
        return console.error(response.message, { autoClose: 500 });
      }
      const {
        data: { Status, responseStatusCode, Data },
      } = response;
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        setAuthorities(Data);
      } else {
        return console.error("Error: Authorities not found");
      }
    })();
  }, []);

  const handlePrevious = async () => {
    if (!currentCouponId && currentCouponId < 1) return;
    await fetchGenerateCouponData("P");
  };

  const handleNext = async () => {
    if (!currentCouponId) return;
    await fetchGenerateCouponData("N");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "DiscAmt") {
      const selectedPromoCode = promocode.find(
        (promo) => promo.Id === form.PromoCodeID
      );
      if (selectedPromoCode?.Name.toLowerCase().includes("free month")) {
        if (parseInt(value) > 12) {
          toast.error("Free Month discount cannot exceed 12 months", { autoClose: 1000 });
          return;
        }
      }
    }

    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEdit = async () => {
    setMode(FORM_MODE.edit);
  };

  const handleAdd = () => {
    setMode(FORM_MODE.add);
    setForm(FORM_INIT_STATE);
  };

  const handleCancel = async (flag = "L") => {
    if (mode === FORM_MODE.add) {
      await fetchGenerateCouponData("L", 1);
    } else {
      await fetchGenerateCouponData("R");
    }
    setMode(FORM_MODE.read);
  };

  const handleExit = () => {
    navigate("/generate-coupon-table");
  };

  const handleDelete = async () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      // First, fetch the coupon details to check if it's redeemed
      const fetchResponse = await retriveMstPromoCodeCoupon({
        CouponId: currentCouponId,
        Flag: "R",
      });

      if (fetchResponse instanceof Error) {
        return console.error("Error: could not fetch coupon details");
      }

      const { data: { Status: fetchStatus, Data: fetchData, Message: fetchMsg } } = fetchResponse;

      if (fetchStatus !== 0 || !Array.isArray(fetchData) || fetchData.length === 0) {
        toast.error(fetchMsg || "Unable to fetch coupon details.", { autoClose: 1000 });
        return;
      }

      const coupon = fetchData[0];

      // Check if RedeemDt is present (i.e., coupon is redeemed)
      // if (bookId ==1) {
      //   toast.warn("This coupon has already been redeemed and can't be deleted.", { autoClose: 2000, });
      //   return;
      // }

      // Proceed with deletion
      await fetchGenerateCouponData("D");

      const deleteResponse = await retriveMstPromoCodeCoupon({
        CouponId: currentCouponId,
        Flag: "D",
      });

      if (deleteResponse instanceof Error) {
        return console.error("Error: could not delete coupon");
      }

      const { data: { Status, Message, Data }, } = deleteResponse;

         if(deleteResponse.data.Status==1){
          toast.error('Coupon is redeemed and cannot be deleted')
          return
         }
      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 3000 });
        } else {
          toast.error(Message, { autoClose: 3000 });
        }
      }
    } catch (error) {
      toast.error("Unexpected error occurred while deleting.", { autoClose: 1000 });
    }
  };

  const fetchGenerateCouponData = async (flag = "R", CouponId = 1) => {
    const response = await retriveMstPromoCodeCoupon({
      CouponId: currentCouponId ?? CouponId,
      Flag: flag,
    });
    if (response instanceof Error) {
      return console.log(response.message);
    }
    const { data: { Status, responseStatusCode, Data, Message },
    } = response;
    if (Status === 0 && responseStatusCode === 1 && Data && Array.isArray(Data)) {
      const data = Data[0];
      setForm(prev => ({
        ...prev,
        PropId: data.PropId,
        PromoCodeID: data.PromoCodeID,
        MobileNo: data.MobileNo,
        ResidentName: data.ResidentName ? data.ResidentName : "",
        AuthId: data.AuthId,
        DiscType: data.DiscType ? data.DiscType : "",
        DiscAmt: data.DiscAmt ? String(data.DiscAmt) : "",
        Status: data.Status,
        ApprovalFlag: data.ApprovalFlag,
      }));
      setStatus(data.Status.toString());
      setCouponNo(data.CouponNo);
      setPromoCodeName(data.PromoCodeName);
      setAuthorityName(data.Name);
      setEmail(data.Email);
      setMode(FORM_MODE.read);
      setCurrentCouponId(data.CouponId);
      setShowSendCouponLink(true);
    } else {
      console.log(Message);
    }
  };

  const handleSubmit = async () => {
    // if (bookId !== 1) {
    //   toast.error("This coupon has already been used/redeemed and cannot be modified.", {
    //     autoClose: 4000,
    //   });
    //   return;
    // }
    const result = couponFormSchema.safeParse(form);

    if (!result.success) {
      return toast.info("Please fill in all required inputs correctly.", {
        autoClose: 1000,
      });
    }
    const { data } = result;

    const property = properties.find((p) => p.Id === data.PropId);

    const isValidNumber = isValidPhone(data.MobileNo, property?.MobDigit);

    const selectedPromoCode = promocode.find(
      (promo) => promo.Id === data.PromoCodeID
    );
    if (selectedPromoCode?.Name.toLowerCase().includes("free month")) {
      const discAmt = parseInt(data.DiscAmt);
      if (discAmt > 12) {
        return toast.error("Free Month discount cannot exceed 12 months", { autoClose: 1000 });
      }
    }

    if (!isValidNumber) {
      return toast.info("Enter a valid phone number", {
        autoClose: 500,
      });
    }

    const currentDate = new Date().toLocaleDateString("en-CA");

    const payload = {
      PromoCodeID: data.PromoCodeID,
      PropId: data.PropId,
      ResidentId: residentId ? residentId : 1,
      ResidentName: data.ResidentName,
      MobileNo: data.MobileNo,
      BookId: bookId ? bookId :1,
      DiscAmt: data.DiscAmt ? data.DiscAmt : 0,
      DiscType: data.DiscType,
      AuthId: data.AuthId,
      AuthDt: currentDate,
      RedeemDt: currentDate,
      Status: data.Status,
    };

    let response;
    if (mode === FORM_MODE.edit && currentCouponId) {
       if (bookId !== 1) {
      toast.error("This coupon has already been used/redeemed and cannot be modified.", {
        autoClose: 4000,
      });
      return;
    }
      payload.CouponId = currentCouponId;
      payload.UpdatedBy = UserId;
      response = await updateMstPromoCodeCoupon(payload);
    } else {
      payload.CreatedBy = UserId;
      response = await insertMstPromoCodeCoupon(payload);
    }

  

    if (response instanceof Error) {
      console.error("Error: Could not submit form");
    }

    const { data: { Status, Message }, } = response;

    if (Status === 1) {
      return toast.warning("Coupon already Exist");
    }

    if (Status === 0) {
      setMode(FORM_MODE.read);
      setShowSendCouponLink(true);
      toast.success(Message, {
        autoClose: 1000,
      });

      // Send email only if AutoMail is checked
      if (autoMail) {
        await handleEmailSentLink();
      }
    } else {
      console.error(Message);
    }
  };

  useEffect(() => {
    if (form.PromoCodeID) {
      const foundPromocode = promocode.find((r) => r.Id === form.PromoCodeID);
      if (!foundPromocode) return;
      const value = parseInt(foundPromocode?.DiscountAmt, 10);
      setForm((prev) => ({
        ...prev,
        DiscountAmt: isNaN(value) ? "" : value,
        DiscType: foundPromocode?.DiscType || "",
      }));
    }
  }, [form.PromoCodeID, promocode]);

  useEffect(() => {
    if (mode === FORM_MODE.read) return;
    (async () => {
      try {
        const selectedProperty = properties.find(
          (property) => property.Id === form.PropId
        );
        const isValid = isValidPhone(form.MobileNo, selectedProperty?.MobDigit);
        if (isValid && form.PropId) {
          const residentName = await getResidentDetails(form.MobileNo.trim());
          if (!residentName) {
            setDialogOpen(true);
          }
          if (residentName) {
            setResidentNameEditable(false);
            setForm((prevState) => ({
              ...prevState,
              ResidentName: residentName.trim() || "",
            }));
          }
        }
      } catch (error) {
        setResidentNameEditable(true);
        console.log(error.message);
      }
    })();
  }, [form.MobileNo, form.PropId]);

  async function getResidentDetails(value) {
    try {
      const response = await axiosInstance.post(
        "ResidentMst/RetriveResidentMstAll",
        {
          ResidentId: 1,
          Flag: "M",
          Mobile: value,
        }
      );
      const { data } = response;
      if (
        data.Status === 0 &&
        data.Data &&
        data.Data.MstResidentList &&
        data.Data.MstResidentList.length > 0
      ) {
        const resident = data.Data.MstResidentList[0];
        setResidentId(data.Data.MstResidentList[0].ResidentId);
        const residentName = `${resident.FirstName} ${resident.MidName ? resident.MidName + " " : ""}${resident.LastName}`;
        return residentName;
      } else {
        return "";
      }
    } catch (error) {
      toast.error("Error: Unable to retrieve resident data.", { autoClose: 500 });
      return "";
    }
  }

  const handleDialogClose = (response) => {
    if (response === "yes") {
      setMode(FORM_MODE.edit);
      setForm((prevState) => ({
        ...prevState,
        ResidentName: "",
      }));
      setResidentNameEditable(true);
    } else {
      setResidentNameEditable(false);
    }
    setDialogOpen(false);
  };

  const buttonSx = {
    backgroundColor: "#635bff",
    borderRadius: "5px",
    padding: "5px",
    margin: { xs: "0px 5px", sm: "0px 5px" },
    "&:hover": {
      backgroundColor: "#1565c0",
      cursor: "pointer",
    },
    minWidth: { xs: "40px", sm: "40px", md: "60px" },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
    },
  };

  return (
    <>
      <ToastContainer />
      <Box className="form-container">
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: "block" ,
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== FORM_MODE.read ||
                  !currentCouponId ||
                  currentCouponId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display:"block",
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== FORM_MODE.read}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Coupon Master
            </Typography>
            <Tooltip title="Send Approval Mail" arrow>
              <span>
                <IconButton
                  sx={buttonSx}
                  onClick={handleEmailSentLink}
                  disabled={mode !== FORM_MODE.read || !showSendCouponLink}
                >
                  <SendIcon sx={{ color: "white" }} />
                </IconButton>
              </span>
            </Tooltip>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Coupon Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} lg={12} className="form_field"
            sx={{ marginInline: { xs: "10px", sm: "80px" } }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={4}>
                    <CustomAutoCompleteNew
                      id="AuthId-select"
                      name="AuthId"
                      options={authorities}
                      value={authorities.find((authority) => authority.Id === form.AuthId) || ""}
                      onChange={handleInputChange}
                      label={
                        <span>
                          Authorities <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      disabled={mode === FORM_MODE.read}
                      onAddClick={openAuthorityTab}
                      onRefreshClick={handleRefreshAuthority}
                      isRefreshing={isRefreshing}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <CustomAutocomplete
                      id="properties-select"
                      name="PropId"
                      options={properties}
                      value={properties.find((property) => property.Id === form.PropId) || ""}
                      onChange={handleInputChange}
                      label={
                        <span>
                          Properties <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="mobileno"
                      name="MobileNo"
                      label={
                        <span>
                          Resident Mobile No.
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.MobileNo}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="residentname"
                      name="ResidentName"
                      label={
                        <span>
                          Resident Name<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.ResidentName}
                      onChange={handleInputChange}
                      disabled={!isResidentNameEditable || mode === FORM_MODE.read}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={4}>
                    <CustomAutocomplete
                      id="promoCodeID-select"
                      name="PromoCodeID"
                      options={promocode}
                      value={promocode.find((promo) => promo.Id === form.PromoCodeID) || ""}
                      onChange={handleInputChange}
                      label={
                        <span>
                          PromoCode <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      disabled={mode === FORM_MODE.read}
                      onRefreshClick={handleRefreshPromo}
                      isRefreshing={isRefreshingPromo}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      id="DiscType"
                      name="DiscType"
                      label="Discount Type"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.DiscType}
                      onChange={handleInputChange}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      id="DiscAmt"
                      name="DiscAmt"
                      label={getDiscountLabel()}
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.DiscAmt}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      inputProps={{
                        max: promocode.find(
                          (promo) => promo.Id === form.PromoCodeID
                        )?.Name.toLowerCase().includes("free month") ? 12 : undefined
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={mode === FORM_MODE.read}
                            checked={Status === "1"}
                            onChange={handleChangeStatus}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={autoMail}
                            onChange={handleMailStatus}
                            disabled={mode === FORM_MODE.read}
                          />
                        }
                        label="AutoMail"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} md={2} justifyContent='flex-end'>
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        ml: "41px",
                        mt: "12px",
                        background: form.ApprovalFlag === "Y" ? "#4caf50" : "#f44336",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        color: "white",
                        padding: "2px 8px",
                        borderRadius: "20px",
                        lineHeight: 1.5,
                      }}
                    >
                      {form.ApprovalFlag === "Y" ? (
                        <CheckCircleIcon sx={{ mr: 0.5 }} />
                      ) : (
                        <CancelIcon sx={{ mr: 0.5 }} />
                      )}
                      <Typography variant="body2" sx={{ color: "white" }}>
                        {form.ApprovalFlag === "Y" ? "Approved" : "Unapproved"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Coupon Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      >
        <DialogTitle>New mobile no found</DialogTitle>
        <DialogContent>
          <p>Would you like to generate a coupon for this number?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogClose("yes")} color="primary">
            Yes
          </Button>
          <Button onClick={() => handleDialogClose("no")} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GenerateCouponMaster;